// import 'babel-polyfill';
// import './_polyfill';
import './components/_slider';

import Accordion from './components/_accordion';

import './components/_modal';

import './components/_search';

import './components/_menu';

import ScrollTo from './components/_scrollTo';

import Roll from './components/_scrollStatus';

import './animations/_loader';

Lazyload.init();

Accordion.init();

ScrollTo.init();

Roll.init();
